import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { notError, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiAlmacenRegistro } from '../../api/apiAlmacenRegistro'
import {
  ALMACEN_INITIAL_VALUES,
  AlmacenBaseProp,
  AlmacenInputProps,
} from '../../interfaces'
import { almacenRegistroComposeService } from '../../services/almacenRegistroComposeService'
import {
  AlmacenRegistroValidationSchema,
  almacenRegistroValidator,
} from '../../validator/almacenRegistro.validator'
import AlmacenForm from '../AlmacenForm'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: AlmacenBaseProp) => void
}

const AlmacenRegistroDialog: FunctionComponent<OwnProps> = (props) => {
  const { onClose, open, ...other } = props
  const form = useForm<AlmacenInputProps>({
    defaultValues: ALMACEN_INITIAL_VALUES,
    resolver: yupResolver<any, any, any>(AlmacenRegistroValidationSchema),
  })
  const confirm = useConfirm()

  /**
   * Registramos el almacen
   * @param values
   */
  const onSubmit: SubmitHandler<AlmacenInputProps> = async (values) => {
    try {
      const val = await almacenRegistroValidator(values)
      if (val.length > 0) {
        notError(val.join('<br>'))
        return
      }
      const apiInput = almacenRegistroComposeService(values)
      const { confirmed } = await confirm()
      if (!confirmed) return

      swalLoading()
      await apiAlmacenRegistro(apiInput)
      notSuccess('Almacén registrado exitosamente') // Mostrar mensaje de éxito
      onClose() // Cierra el diálogo después de mostrar el mensaje
    } catch (e: any) {
      if (e.response?.errors?.[0]?.extensions?.code === 'USER_INPUT_ERROR') {
        notError(e.response.errors[0].message)
      } else {
        swalException(e)
      }
    } finally {
      swalClose()
    }
  }

  const onError = (errors: any, e: any) => {
    console.log(errors, e)
  }

  useEffect(() => {
    if (open) {
      form.reset(ALMACEN_INITIAL_VALUES)
    }
  }, [open, form])

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '80vh' } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Nuevo Almacen</DialogTitle>
      <DialogContent dividers>
        <AlmacenForm form={form} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus color="error" size="small" onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size="small"
          sx={{ mr: 2 }}
          variant="contained"
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AlmacenRegistroDialog
